import { render, staticRenderFns } from "./UploadProjectFiles.vue?vue&type=template&id=77e8e270"
import script from "./UploadProjectFiles.vue?vue&type=script&lang=js"
export * from "./UploadProjectFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports